// errorEmitter.ts
import EventEmitter from 'eventemitter3';

const errorEmitter = new EventEmitter();

export const emitError = (title: string, message: string, statusCode: string) => {
    errorEmitter.emit('error', { title, message, statusCode });
};

export const onError = (callback: (error: { title: string; message: string; statusCode: string }) => void) => {
    errorEmitter.on('error', callback);
};

export const offError = (callback: (error: { title: string; message: string; statusCode: string }) => void) => {
    errorEmitter.off('error', callback);
};
